import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getCurrentRichContent } from "../helpers/richContentHelpers";

const solutionsPageTplData = (id) => {
    const data = useStaticQuery(
        graphql`
            {
                allWpPage {
                    edges {
                        node {
                            id
                            template {
                                ... on WpTemplate_Solutions {
                                    solutionsRichContent {
                                        hero {
                                            category
                                            header
                                            secondHeader
                                            text
                                            buttons {
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                            image {
                                                localFile {
                                                    extension
                                                    childImageSharp {
                                                        gatsbyImageData(
                                                            width: 1800
                                                            placeholder: BLURRED
                                                            quality: 100
                                                        )
                                                    }
                                                }
                                            }
                                        }
                                        anchorNav {
                                            label
                                            target
                                        }
                                        benefits {
                                            slug
                                            header
                                            items {
                                                icon {
                                                    ...wpImageFluid
                                                }
                                                title
                                                description
                                            }
                                        }
                                        socialProof {
                                            header
                                            statsHeader
                                            trustedByLogos {
                                                image {
                                                    ...wpImageFluid
                                                }
                                            }
                                            stats {
                                                number
                                                label
                                            }
                                            testimonials {
                                                quote
                                                companyLogo {
                                                    ...wpImageFluid
                                                }
                                            }
                                        }

                                        # SECTION: Key Features
                                        keyFeatures {
                                            imageSection {
                                                category
                                                title
                                                text
                                                slug
                                                variant
                                                image {
                                                    ...wpImageFluid
                                                }
                                                items {
                                                    category
                                                    title
                                                    text
                                                    button {
                                                        variant
                                                        link {
                                                            target
                                                            title
                                                            url
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        # SECTION: Operating Model (Lottie animation)
                                        operatingModel {
                                            slug
                                            header
                                            description
                                            lottieSrc {
                                                localFile {
                                                    publicURL
                                                }
                                            }
                                            lottieSrcMobile {
                                                localFile {
                                                    publicURL
                                                }
                                            }
                                        }

                                        # SECTION: Security Section
                                        imageSection {
                                            category
                                            title
                                            text
                                            slug
                                            variant
                                            image {
                                                ...wpImageFluid
                                            }
                                            items {
                                                category
                                                title
                                                text
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                        }

                                        industryCases {
                                            slug
                                            header
                                            cases {
                                                title
                                                description
                                                image {
                                                    ...wpImageFluid
                                                }
                                                link {
                                                    target
                                                    title
                                                    url
                                                }
                                            }
                                        }

                                      # SECTION: FAQ
                                      faqSection {
                                        header
                                        items {
                                          question
                                          answer
                                        }
                                    }
                                    }
                                }
                        }
                    }
                }
            }
                                        }
`
    );

    return getCurrentRichContent(data, id, "solutionsRichContent");
};

export { solutionsPageTplData };
